export const trimWhitespace = values => {
  for (const key in values) {
    if (typeof values[key] === 'string') values[key] = values[key].trim();
  }
  return values;
};
